import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl, intlShape} from 'react-intl';

import Box from '../box/box.jsx';
import Modal from '../modal/modal.jsx';
import ExtensionModal from '../extension-modal/extension-modal.jsx';
import LibraryItem from '../library-item/library-item.jsx';
import Filter from '../filter/filter.jsx';
import TagButton from '../../containers/tag-button.jsx';
import Storage from '../../lib/storage';
import placeholderIcon from './placeholder-icon.jpg';
import iconFont from '../../css/iconfont.css';
import styles from './library.css';

// const ALL_TAG_TITLE = 'All';
// const tagListPrefix = [{title: ALL_TAG_TITLE}];

const messages = defineMessages({
    filterPlaceholder: {
        id: 'gui.library.filterPlaceholder',
        defaultMessage: 'Search',
        description: 'Placeholder text for library search field'
    },
    upload: {
        id: 'gui.assetPanel.upload',
        defaultMessage: 'Upload',
        description: 'text for uploading material by yourself'
    },
    paint: {
        id: 'gui.assetPanel.paint',
        defaultMessage: 'Paint',
        description: 'text for painting a picture by yourself'
    },
    allTag: {
        id: 'gui.library.allTag',
        defaultMessage: 'All',
        description: 'Label for library tag to revert to all items after filtering by tag.'
    }

});


const ALL_TAG = {tag: 'all', intlLabel: messages.allTag};
const tagListPrefix = [ALL_TAG];
class LibraryComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleBlur',
            'handleClose',
            'handleFilterChange',
            'handleFilterClear',
            'handleFocus',
            'handleMouseEnter',
            'handleMouseLeave',
            'handleSelect',
            'handleExtenSelect',
            'handleTagClick',
            'setFilteredDataRef',
            'handleImgLoaded'
        ]);
        this.successImgs = [];
        this.state = {
            selectedItem: null,
            filterQuery: '',
            selectedTag: ALL_TAG.tag,
            successImgs: []
        };
    }
    componentDidUpdate (prevProps, prevState) {
        if (prevState.filterQuery !== this.state.filterQuery ||
            prevState.selectedTag !== this.state.selectedTag) {
            this.scrollToTop();
        }
    }
    handleBlur (id) {
        this.handleMouseLeave(id);
    }
    handleFocus (id) {
        this.handleMouseEnter(id);
    }
    handleImgLoaded (id) {
        if (this.successImgs.find(i => i === id) === undefined) {
            this.successImgs.push(id);
        }
    }
    handleSelect (id) {
        const dataItem = this.getFilteredData()[id];
        const md5 = dataItem.md5 ? dataItem.md5 : dataItem.rawURL;
        if (this.props.id === 'soundLibrary' || this.successImgs.find(i => i === md5) !== undefined){
            this.handleClose();
            this.props.onItemSelected(dataItem);
        } else {
            // eslint-disable-next-line no-alert
            alert('角色造型还未加载完整，请将鼠标悬停在角色上！');
        }
    }
    handleExtenSelect (id) {
        this.handleClose();
        this.props.onItemSelected(this.getFilteredData()[id]);
    }
    handleClose () {
        this.props.onRequestClose();
    }
    handleTagClick (tag) {
        this.setState({
            filterQuery: '',
            selectedTag: tag.toLowerCase()
        });
    }
    handleMouseEnter (id) {
        if (this.props.onItemMouseEnter) this.props.onItemMouseEnter(this.getFilteredData()[id]);
    }
    handleMouseLeave (id) {
        if (this.props.onItemMouseLeave) this.props.onItemMouseLeave(this.getFilteredData()[id]);
    }
    handleFilterChange (event) {
        this.setState({
            filterQuery: event.target.value,
            selectedTag: ALL_TAG.tag
        });
    }
    handleFilterClear () {
        this.setState({filterQuery: ''});
    }
    getFilteredData () {
        if (this.state.selectedTag === 'all') {
            if (!this.state.filterQuery) return this.props.data;
            return this.props.data.filter(dataItem => (
                (dataItem.tags || [])
                    // Second argument to map sets `this`
                    .map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
                    .concat(dataItem.name.toLowerCase())
                    .join('\n') // unlikely to partially match newlines
                    .indexOf(this.state.filterQuery.toLowerCase()) !== -1
            ));
        }
        return this.props.data.filter(dataItem => (
            dataItem.tags &&
            dataItem.tags
                .map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
                .indexOf(this.state.selectedTag) !== -1
        ));
    }
    scrollToTop () {
        this.filteredDataRef.scrollTop = 0;
    }
    setFilteredDataRef (ref) {
        this.filteredDataRef = ref;
    }
    render () {
        const BolExtension = this.props.id === 'extensionLibrary';
        return BolExtension ? (
            <ExtensionModal
                contentLabel={this.props.title}
                id={this.props.id}
                overlayClassName={styles.modalOverlay}
                onRequestClose={this.props.onRequestClose}
            >
                <Box
                    className={styles.body}
                    direction="column"
                >
                    <div
                        className={classNames(styles.libraryScrollGrid, styles.extensionlibraryScrollGrid, {
                            [styles.withFilterBar]: this.props.filterable || this.props.tags
                        })}
                        ref={this.setFilteredDataRef}
                    >
                        {this.getFilteredData().map((dataItem, index) => {
                            const baseUrl = Storage.getAssetHost();
                            const scratchURL = dataItem.md5 ?
                                `${baseUrl}/internalapi/asset/${dataItem.md5}/get/` :
                                dataItem.rawURL;
                            return (
                                <LibraryItem
                                    description={dataItem.description}
                                    disabled={dataItem.disabled}
                                    featured={dataItem.featured}
                                    iconURL={scratchURL}
                                    insetIconURL={dataItem.insetIconURL}
                                    id={index}
                                    key={`item_${index}`}
                                    name={dataItem.name}
                                    show={dataItem.show}
                                    onBlur={this.handleBlur}
                                    onFocus={this.handleFocus}
                                    onMouseEnter={this.handleMouseEnter}
                                    onMouseLeave={this.handleMouseLeave}
                                    onSelect={this.handleExtenSelect}
                                />
                            );
                        })}
                    </div>
                </Box>
            </ExtensionModal>
        ) : (
            <Modal
                className={styles.spriteContainer}
                contentLabel={this.props.title}
                id={this.props.id}
                overlayClassName={styles.modalOverlay}
                onRequestClose={this.props.onRequestClose}
            >
                <Box
                    className={styles.body}
                    direction="column"
                >
                    <div className={styles.header}>
                        <div
                            className={styles.filterBar}
                        >
                            <div
                                className={classNames(
                                    styles.filterBarItem,
                                    styles.title
                                )}
                            >
                                {this.props.title}
                            </div>
                            {this.props.filterable && (
                                <Filter
                                    className={classNames(
                                        styles.filterBarItem,
                                        styles.filter
                                    )}
                                    filterQuery={this.state.filterQuery}
                                    inputClassName={styles.filterInput}
                                    placeholderText={this.props.intl.formatMessage(messages.filterPlaceholder)}
                                    onChange={this.handleFilterChange}
                                    onClear={this.handleFilterClear}
                                />
                            )}
                            {
                                this.props.id === 'spriteLibrary' ? (
                                    <div
                                        className={classNames(styles.btn)}
                                        onClick={this.props.onFileUploadClick}
                                    >
                                        <i className={classNames(iconFont.iconfont, iconFont.iconShangchuan)} />
                                        {this.props.intl.formatMessage(messages.upload)}
                                        <input
                                            accept={this.props.fileAccept}
                                            className={styles.fileInput}
                                            multiple="true"
                                            ref={this.props.fileInputRef}
                                            type="file"
                                            onChange={this.props.onSpriteUpload}
                                        />
                                    </div>) : null
                            }
                            {
                                this.props.id === 'spriteLibrary' ? (
                                    <div
                                        className={classNames(styles.btn)}
                                        onClick={this.props.onPaintClick}
                                    >
                                        <i className={classNames(iconFont.iconfont, iconFont.iconZijihua)} />
                                        {this.props.intl.formatMessage(messages.paint)}
                                    </div>) : null
                            }
                        </div>
                    </div>
                    <div
                        className={styles.content}
                    >
                        {(this.props.filterable || this.props.tags) && (
                            <div className={styles.tagWrapper}>
                                {tagListPrefix.concat(this.props.tags).map((tagProps, id) => (
                                    <TagButton
                                        active={this.state.selectedTag === tagProps.tag.toLowerCase()}
                                        className={classNames(
                                            styles.filterBarItem,
                                            styles.tagButton,
                                            tagProps.className
                                        )}
                                        iconSrc={placeholderIcon}
                                        key={`tag-button-${id}`}
                                        onClick={this.handleTagClick}
                                        {...tagProps}
                                    />
                                ))}
                            </div>
                        )}
                        <div
                            className={classNames(styles.libraryScrollGrid, {
                                [styles.withFilterBar]: this.props.filterable || this.props.tags
                            })}
                            ref={this.setFilteredDataRef}
                        >
                            {this.getFilteredData().map((dataItem, index) => {
                                const baseUrl = Storage.getAssetHost();
                                const scratchURL = dataItem.md5 ?
                                    `${baseUrl}/internalapi/asset/${dataItem.md5}/get/` :
                                    dataItem.rawURL;
                                return (
                                    <LibraryItem
                                        description={dataItem.description}
                                        disabled={dataItem.disabled}
                                        featured={dataItem.featured}
                                        iconURL={scratchURL}
                                        id={index}
                                        key={`item_${index}`}
                                        md5={dataItem.md5 ? dataItem.md5 : dataItem.rawURL}
                                        name={dataItem.name}
                                        show={dataItem.show}
                                        onBlur={this.handleBlur}
                                        onFocus={this.handleFocus}
                                        onImgLoaded={this.handleImgLoaded}
                                        onMouseEnter={this.handleMouseEnter}
                                        onMouseLeave={this.handleMouseLeave}
                                        onSelect={this.handleSelect}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </Box>
            </Modal>
        );
    }
}

LibraryComponent.propTypes = {
    data: PropTypes.arrayOf(
        /* eslint-disable react/no-unused-prop-types, lines-around-comment */
        // An item in the library
        PropTypes.shape({
            // @todo remove md5/rawURL prop from library, refactor to use storage
            md5: PropTypes.string,
            name: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.node
            ]).isRequired,
            rawURL: PropTypes.string
        })
        /* eslint-enable react/no-unused-prop-types, lines-around-comment */
    ),
    fileAccept: PropTypes.string,
    fileInputRef: PropTypes.func,
    filterable: PropTypes.bool,
    id: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
    onFileUploadClick: PropTypes.func,
    onItemMouseEnter: PropTypes.func,
    onItemMouseLeave: PropTypes.func,
    onItemSelected: PropTypes.func,
    onPaintClick: PropTypes.func,
    onRequestClose: PropTypes.func,
    onSpriteUpload: PropTypes.func,
    show: PropTypes.bool,
    tags: PropTypes.arrayOf(PropTypes.shape(TagButton.propTypes)),
    title: PropTypes.string.isRequired
};

LibraryComponent.defaultProps = {
    filterable: true
};

export default injectIntl(LibraryComponent);
